/** Shared holiday bank / policy helpers */

export const HOLIDAY_TYPE_OPTIONS = [
  { value: "national", label: "National" },
  { value: "festival", label: "Festival" },
  { value: "public", label: "Public / Company" },
  { value: "regional", label: "Regional" },
  { value: "restricted", label: "Restricted Holiday" },
];

export const HOLIDAY_TYPE_LABELS = Object.fromEntries(
  HOLIDAY_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export function formatHolidayTypeLabel(type) {
  const key = String(type || "").toLowerCase();
  return HOLIDAY_TYPE_LABELS[key] || String(type || "Public");
}

export function holidayYear(date) {
  if (!date) return null;
  const y = Number(String(date).slice(0, 4));
  return Number.isFinite(y) ? y : null;
}

export function collectHolidayYears(holidays = [], fallbackYear = new Date().getFullYear()) {
  const years = new Set();
  (holidays || []).forEach((h) => {
    const y = holidayYear(h?.date);
    if (y != null) years.add(y);
  });
  if (!years.size) years.add(fallbackYear);
  return Array.from(years).sort((a, b) => b - a);
}

export function groupHolidaysByYear(holidays = []) {
  const map = new Map();
  (holidays || []).forEach((h) => {
    const y = holidayYear(h?.date) ?? "Unknown";
    if (!map.has(y)) map.set(y, []);
    map.get(y).push(h);
  });
  for (const list of map.values()) {
    list.sort((a, b) => String(a.date || "").localeCompare(String(b.date || "")));
  }
  return map;
}

export function holidayTypeTone(type) {
  const t = String(type || "").toLowerCase();
  if (t === "restricted") return "warning";
  if (t === "national") return "info";
  if (t === "festival") return "primary";
  return "neutral";
}

export const EMPTY_HOLIDAY_BANK_FORM = {
  date: "",
  name: "",
  type: "national",
  description: "",
};
